// extracted by mini-css-extract-plugin
module.exports = {"bgVideoContainer":"backgroundVideo_bgVideoContainer__3CME7","overlay":"backgroundVideo_overlay__2MwBy"};